export default __webpack_public_path__ + "static/media/towerb.0ccd22d3.png";